<template>
  <BaseTemplate app-name="Gestão de Ativos" page-title="">
    <template #content>
      <div class="container mx-auto px-4 py-4 md:py-8">
        <!-- Cabeçalho -->
        <button
  @click="voltar"
  class="hidden md:inline-flex mb-5 items-center gap-2 bg-blue-500 dark:bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors dark:hover:bg-blue-700"
>
  <SquareArrowLeft class="w-5 h-5" />
  <span>Voltar</span>
</button>
        <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          
          <h1 class="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <ShieldCheck class="w-6 h-6 text-blue-500" />
            Gerenciamento de Tokens de Acesso
          </h1>
        </div>

        <!-- Descrição -->
        <div class="bg-blue-50 dark:bg-gray-800 p-4 rounded-lg mb-6 border-l-4 border-blue-500">
          <p class="text-gray-700 dark:text-gray-300">
            Este módulo permite gerar e gerenciar tokens de acesso para equipamentos. Cada token é único e pode ser associado ao endereço MAC de uma máquina para autorização de acesso.
          </p>
        </div>

        <!-- Formulário de Associação -->
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 sm:p-6 mb-6">
          <h2 class="text-xl font-semibold text-gray-800 dark:text-white mb-4 flex items-center gap-2">
            <LinkIcon class="w-5 h-5 text-blue-500" />
            Associar Token a Equipamento
          </h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Token Gerado</label>
              <div class="flex flex-col sm:flex-row gap-2">
                <input type="text" v-model="tokenAtual" readonly class="w-full border rounded-lg px-4 py-2 bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                <button @click="copiarToken" class="w-full sm:w-auto bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 px-4 py-2 rounded-lg flex items-center justify-center">
                  <Copy class="w-5 h-5 text-gray-700 dark:text-gray-300" />
                </button>
              </div>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Token gerado automaticamente no formato xxxxx-xxxxx-xxxxx-xxxxx</p>
            </div>

            <!-- Filtros -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full mt-4 sm:mt-0">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Equipamento</label>
                <select v-model="filtroTipoEquipamento" class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <option value="">Todos os tipos</option>
                  <option v-for="tipo in tiposDisponiveis" :key="tipo" :value="tipo">{{ tipo }}</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Modelo</label>
                <select v-model="filtroModeloEquipamento" class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <option value="">Todos os modelos</option>
                  <option v-for="modelo in modelosDisponiveis" :key="modelo" :value="modelo">{{ modelo }}</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Serial Number</label>
                <input type="text" v-model="filtroSerialNumber" placeholder="Digite o serial number" class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
              </div>
            </div>
          </div>

          <!-- Equipamentos -->
          <div class="mt-4">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Equipamento</label>
            <select v-model="selectedEquipment" @change="selecionarEquipamento" class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <option value="" disabled>Selecione um equipamento</option>
              <option v-for="modelo in equipamentosFiltrados" :key="modelo.id" :value="modelo.id">{{ modelo.serial_number }} - {{ modelo.modelo_nome }}</option>
            </select>
          </div>

          <!-- Unidades -->
          <div class="mt-4">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidade</label>
            <select v-model="selectedUnidade" class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <option value="" disabled>Selecione uma unidade</option>
              <option v-for="unidade in unidades" :key="unidade.id" :value="unidade.id">{{ unidade.nome }}</option>
            </select>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Selecione a unidade apenas para o servidor que irá enviar as métricas</p>
          </div>

          <!-- Detalhes -->
          <div v-if="equipamentoSelecionado" class="mt-6">
            <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Detalhes do Equipamento</h3>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div v-for="(valor, chave) in equipamentoSelecionado" :key="chave">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 capitalize">{{ chave.replaceAll('_', ' ') }}</label>
                <p class="text-sm text-gray-900 dark:text-white">{{ valor }}</p>
              </div>
            </div>
          </div>

          <div class="flex justify-end mt-6">
            <button @click="handleGerarToken" class="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-md">
              <KeyIcon class="w-5 h-5" />
              Gerar Token
            </button>
          </div>
        </div>

        <!-- Lista de Tokens -->
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden">
          <div class="p-4 bg-gray-50 dark:bg-gray-700 border-b dark:border-gray-600">
            <h2 class="text-xl font-semibold text-gray-800 dark:text-white flex items-center gap-2">
              <ListIcon class="w-5 h-5 text-blue-500" />
              Tokens Ativos
            </h2>
          </div>

          <!-- Filtros da Tabela -->
          <div class="p-4 border-b dark:border-gray-600 bg-gray-50 dark:bg-gray-700">
            <div class="flex flex-col sm:flex-row gap-4">
              <input type="text" v-model="filtroToken" placeholder="Filtrar por token" 
                @input="handleFiltroChange"
                class="flex-1 border rounded-lg px-4 py-2 dark:bg-gray-600 dark:border-gray-500 dark:text-white" />
              <input type="text" v-model="filtroEquipamento" placeholder="Filtrar por Serial Number" 
                @input="handleFiltroChange"
                class="flex-1 border rounded-lg px-4 py-2 dark:bg-gray-600 dark:border-gray-500 dark:text-white" />
              <select v-model="filtroStatus" @change="handleFiltroChange"
                class="flex-1 border rounded-lg px-4 py-2 dark:bg-gray-600 dark:border-gray-500 dark:text-white">
                <option value="">Todos os status</option>
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </select>
            </div>
          </div>

          <!-- Tabela -->
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead class="bg-blue-500 dark:bg-blue-600 text-white">
                <tr>
                  <th @click="handleSort('token')" 
                      class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider cursor-pointer hover:bg-blue-600">
                    Token
                    <span v-if="sortColumn === 'token'">{{ sortDirection === 'asc' ? '⭡' : '⭣' }}</span>
                  </th>
                  <th @click="handleSort('equipmentName')" 
                      class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider cursor-pointer hover:bg-blue-600">
                    Equipamento
                    <span v-if="sortColumn === 'equipmentName'">{{ sortDirection === 'asc' ? '⭡' : '⭣' }}</span>
                  </th>
                  <th @click="handleSort('status')" 
                      class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider cursor-pointer hover:bg-blue-600">
                    Status
                    <span v-if="sortColumn === 'status'">{{ sortDirection === 'asc' ? '⭡' : '⭣' }}</span>
                  </th>
                  <th @click="handleSort('unidade')" 
                      class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider cursor-pointer hover:bg-blue-600">
                    Unidade
                    <span v-if="sortColumn === 'unidade'">{{ sortDirection === 'asc' ? '⭡' : '⭣' }}</span>
                  </th>
                  <th class="px-4 py-2 text-left text-xs font-medium uppercase tracking-wider">Ações</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                <tr v-for="token in tokensPaginados" :key="token.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                  <td class="px-4 py-2 text-sm font-medium text-gray-900 dark:text-white">{{ token.token }}</td>
                  <td class="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">{{ token.equipmentName }}</td>
                  <td class="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">
                    <span :class="getStatusClass(token.status)">
                      {{ token.status }}
                    </span>
                  </td>
                  <td class="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">{{ token.unidade }}</td>
                  <td class="px-4 py-2 text-sm text-gray-500 dark:text-gray-400">
                    <button @click="revogarToken(token.id)" 
                            class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300">
                      <Trash2 class="w-5 h-5" />
                    </button>
                  </td>
                </tr>
                <tr v-if="tokensPaginados.length === 0">
                  <td colspan="5" class="px-4 py-4 text-center text-gray-500 dark:text-gray-400">
                    Nenhum token encontrado
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginação -->
          <div class="flex flex-col md:flex-row md:items-center md:justify-between p-4 gap-4 bg-gray-50 dark:bg-gray-700">
            <div class="flex items-center justify-center gap-2">
              <button @click="currentPage--" 
                      :disabled="currentPage === 1"
                      class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-600 text-white disabled:opacity-50">
                Anterior
              </button>
              <span class="text-sm text-gray-700 dark:text-gray-300">
                Página {{ currentPage }} de {{ totalPages }}
              </span>
              <button @click="currentPage++" 
                      :disabled="currentPage === totalPages"
                      class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-600 text-white disabled:opacity-50">
                Próxima
              </button>
            </div>
            <div class="flex items-center justify-center gap-2">
              <label for="page-size" class="text-sm text-gray-700 dark:text-gray-300">
                Itens por página:
              </label>
              <select id="page-size" 
                      v-model="pageSize" 
                      @change="handlePageSizeChange"
                      class="rounded border px-2 py-1 text-sm dark:bg-gray-600 dark:text-white">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </select>
              <span v-if="totalCount !== null" class="text-xs text-gray-500 dark:text-gray-400">
                Total: {{ totalCount }}
              </span>
            </div>
          </div>
        </div>

      </div>
    </template>
  </BaseTemplate>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import { useRouter } from 'vue-router';
import { 
  ShieldCheck, 
  KeyIcon, 
  LinkIcon, 
  Copy, 
  ListIcon,
  SquareArrowLeft,
  Trash2
} from 'lucide-vue-next';
import apiClient from '@/services/authService';

const router = useRouter()
const tokenAtual = ref('');
const selectedEquipment = ref('');
const equipments = ref([]);
const tokens = ref([]);
const filtroToken = ref('');
const filtroEquipamento = ref('');
const equipamentoSelecionado = ref(null);
const modelos = ref([]);
const selectedUnidade = ref('');
const unidades = ref([]);

// Paginação
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(null);

// Ordenação
const sortColumn = ref('created_at');
const sortDirection = ref('desc');

// Filtros adicionais
const filtroStatus = ref('');

const handleGerarToken = async () => {
  if (!selectedEquipment.value) {
    alert('Por favor, selecione um equipamento antes de gerar o token.');
    return;
  }
  await gerarNovoToken(selectedEquipment.value, selectedUnidade.value);
  // Remove o equipamento gerado da lista
  modelos.value = modelos.value.filter(modelo => modelo.id !== selectedEquipment.value);
  // Limpa seleção após gerar
  selectedEquipment.value = '';
  equipamentoSelecionado.value = null;
  selectedUnidade.value = '';
};

// Funções
const gerarNovoToken = async (ativoId, unidadeId) => {
  try {
    const payload = {};
    if (unidadeId) {
      payload.unidade_id = unidadeId;
    }
    const response = await apiClient.post(`/api/v1/actives/${ativoId}/generate-token/`, payload);
    tokenAtual.value = response.data.token;
  } catch (error) {
    console.error('Erro ao gerar novo token:', error);
    alert(`Erro ao gerar novo token: ${error.response?.data?.detail || error.message}`);
  }
};

const copiarToken = () => {
  navigator.clipboard.writeText(tokenAtual.value)
    .then(() => {
      alert('Token copiado para a área de transferência!');
    })
    .catch(err => {
      console.error('Erro ao copiar token: ', err);
    });
};

const selecionarEquipamento = () => {
  const equipment = equipments.value.find(e => e.id === selectedEquipment.value);
  equipamentoSelecionado.value = equipment ? {
    hostname: equipment.hostname,
    service_tag: equipment.service_tag,
    model: equipment.model,
    processor: equipment.processor,
    ram: equipment.ram,
    storage: equipment.storage,
    ip_address: equipment.ip_address,
    domain: equipment.domain,
    os: equipment.os,
    received_at: equipment.received_at
  } : null;
};

// Função para carregar tokens
const carregarTokens = async () => {
  try {
    // Construir parâmetros da URL
    const params = new URLSearchParams();
    
    // Paginação
    params.append('page', currentPage.value);
    params.append('page_size', pageSize.value);
    
    // Filtros
    if (filtroToken.value) params.append('token', filtroToken.value);
    if (filtroEquipamento.value) params.append('serial_number', filtroEquipamento.value);
    if (filtroStatus.value) params.append('status', filtroStatus.value);
    
    // Ordenação
    if (sortColumn.value) params.append('sortColumn', sortColumn.value);
    if (sortDirection.value) params.append('sortDirection', sortDirection.value);
    
    // Sempre trazer apenas tokens ativos
    params.append('com_token', 'true');

    const response = await apiClient.get(`/api/v1/actives/?${params.toString()}`);
    
    if (response.status === 200) {
      // Mapear os dados recebidos
      tokens.value = (response.data.items || []).map(ativo => ({
        id: ativo.id,
        token: ativo.token,
        equipmentName: `${ativo.serial_number} - ${ativo.modelo_nome}`,
        status: ativo.status,
        unidade: ativo.unidade_nome
      }));
      
      // Atualizar informações de paginação
      totalCount.value = response.data.count;
      totalPages.value = response.data.pages;
      currentPage.value = response.data.page;
    }
  } catch (error) {
    console.error('Erro ao carregar tokens:', error);
    alert(`Erro ao carregar tokens: ${error.response?.data?.detail || error.message}`);
  }
};

// Computed property para tokens paginados (agora só retorna os tokens, pois a paginação é feita no backend)
const tokensPaginados = computed(() => tokens.value);

// Funções de manipulação
const handleSort = (column) => {
  if (sortColumn.value === column) {
    sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortColumn.value = column;
    sortDirection.value = 'asc';
  }
  carregarTokens(); // Recarregar com nova ordenação
};

const handlePageSizeChange = () => {
  currentPage.value = 1;
  carregarTokens();
};

const handleFiltroChange = () => {
  currentPage.value = 1;
  carregarTokens();
};

// Watch para recarregar quando mudar página
watch([currentPage], () => {
  carregarTokens();
});

const getStatusClass = (status) => {
  switch (status) {
    case 'ativo':
      return 'text-green-600 dark:text-green-400';
    case 'inativo':
      return 'text-red-600 dark:text-red-400';
    default:
      return 'text-gray-600 dark:text-gray-400';
  }
};

const revogarToken = async (tokenId) => {
  if (!confirm('Tem certeza que deseja revogar este token?')) return;
  
  try {
    await apiClient.delete(`/api/v1/actives/tokens/${tokenId}/`);
    await carregarTokens();
  } catch (error) {
    console.error('Erro ao revogar token:', error);
    alert(`Erro ao revogar token: ${error.response?.data?.detail || error.message}`);
  }
};

// Lifecycle hooks
onMounted(async () => {
  try {
    // Busca unidades
    const unidadesResponse = await apiClient.get('/api/v1/enterprises/');
    if (unidadesResponse.status === 200) {
      unidades.value = unidadesResponse.data;
    }
    // Usa apiClient para fazer as requisições
    const modelosResponse = await apiClient.get('/api/v1/actives/?disponiveis=true&page_size=100&?com_token=false');
    const tokensResponse = await apiClient.get('/api/v1/actives/?com_token=true');

    if (modelosResponse.status === 200) {
      modelos.value = modelosResponse.data.items || modelosResponse.data;
    } else {
      throw new Error('Erro ao carregar modelos');
    }

    if (tokensResponse.status === 200) {
      const ativos = tokensResponse.data.items || tokensResponse.data;
      tokens.value = ativos.map(ativo => ({
        id: ativo.id,
        token: ativo.token,
        equipmentName: `${ativo.serial_number} - ${ativo.modelo_nome}`,
        status: ativo.status,
        unidade: ativo.unidade_nome
      }));
    } else {
      throw new Error('Erro ao carregar tokens');
    }
  } catch (error) {
    console.error('Erro ao carregar dados:', error);
    alert(`Erro ao carregar dados: ${error.message}`);
  }
});

const voltar = () => router.go(-1);

const filtroTipoEquipamento = ref('');
const filtroSerialNumber = ref('');
const filtroModeloEquipamento = ref('');

// Computed: tipos únicos de equipamento
const tiposDisponiveis = computed(() => {
  const tipos = modelos.value.map(m => m.tipo); // Certifique-se de que existe a propriedade `tipo`
  return [...new Set(tipos)].sort();
});

// Computed: modelos únicos baseados no tipo selecionado
const modelosDisponiveis = computed(() => {
  const modelosFiltrados = modelos.value.filter(m => {
    return filtroTipoEquipamento.value === '' || m.tipo === filtroTipoEquipamento.value;
  });

  const modelosUnicos = modelosFiltrados.map(m => m.modelo_nome);
  return [...new Set(modelosUnicos)].sort();
});

// Computed: equipamentos filtrados com base nos filtros
const equipamentosFiltrados = computed(() => {
  return modelos.value.filter(modelo => {
    const matchTipo = filtroTipoEquipamento.value === '' || modelo.tipo === filtroTipoEquipamento.value;
    const matchModelo = filtroModeloEquipamento.value === '' || modelo.modelo_nome === filtroModeloEquipamento.value;
    const matchSerial = modelo.serial_number?.toLowerCase().includes(filtroSerialNumber.value.toLowerCase());
    return matchTipo && matchModelo && matchSerial;
  });
});
</script>
